import { render } from "./RecruitmentTab1.vue?vue&type=template&id=10912432&scoped=true"
import script from "./RecruitmentTab1.vue?vue&type=script&lang=js"
export * from "./RecruitmentTab1.vue?vue&type=script&lang=js"

import "./RecruitmentTab1.vue?vue&type=style&index=0&id=10912432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10912432"]])

export default __exports__